import { OverviewSectionBadge } from "@/components/portfolio/all-estate-overview/OverviewSectionBadge";
import { Panel } from "@/components/ui/Panel";
import type { ComponentType, ReactNode, SVGProps } from "react";

type SingleEstateInfoPanelProps = {
  badge: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  children?: ReactNode;
  emptyMessage?: string;
  title?: string;
  description?: string;
};

export function SingleEstateInfoPanel({
  badge,
  icon: Icon,
  children,
  emptyMessage,
  title = "",
  description = "",
}: SingleEstateInfoPanelProps) {
  const hasContent = Boolean(children);

  return (
    <Panel>
      <div className="flex items-start gap-3">
        <div className={`icon-wrapper`}>
          <Icon className="size-5" />
        </div>

        <div className="min-w-0 flex-1 space-y-1">
          <OverviewSectionBadge>{badge}</OverviewSectionBadge>
        </div>
      </div>
      {title && <p className="app-card-title">{title}</p>}
      {description && <p className="app-card-description">{description}</p>}
      <Panel variant="compact">
        {hasContent ? (
          <div className="space-y-2">{children}</div>
        ) : (
          <p className="app-card-description text-sm leading-6">
            {emptyMessage}
          </p>
        )}
      </Panel>
    </Panel>
  );
}
